// extracted by css-extract-rspack-plugin
export default {"item":"ListGroup__item--fQGoy","arrow":"ListGroup__arrow--MJx2E","title":"ListGroup__title--j73f_ ListGroup__item--fQGoy","group":"ListGroup__group--YWxEL"};